import React, { FC } from 'react'
import { Button, Dropdown, Menu } from "antd";
import { EllipsisOutlined } from '@ant-design/icons';
import { usePermissionContext } from "../../hooks/context/usePermissionContext";
import { useTranslation } from "react-i18next";
interface IProps {
    bulkAction: any,
    handleCallbackFunc: (event: any, action: string, recordId?: any, data?: any) => void,
    [key: string]: any,
}

const BulkAction: FC<IProps> = props => {
    const { bulkAction, handleCallbackFunc, ...restProps } = props;
    const { t } = useTranslation();
    const { isPermissionLoaded, hasPermission } = usePermissionContext();
    const bulkActionDropDownList = (
        <Menu>
            {bulkAction.action_list.map((item, index) => {
                if (isPermissionLoaded && hasPermission(item.permission)) {
                    return (
                        <Menu.Item key={`${index}`}>
                            {item.type == 'item' && (
                                <Button type="text" onClick={() => handleCallbackFunc('bulkAction', item.action)}>{t(item.title)}</Button>
                            )}
                            {item.type == 'load_drawer_view' && (
                                <Button type="text">{item.component}</Button>
                            )}
                            {item.type == 'component' && (
                                <item.component handleCallbackFunc={handleCallbackFunc} {...restProps} />
                            )}
                        </Menu.Item>
                    );
                }
            })}
        </Menu>
    );

    if (isPermissionLoaded && hasPermission(bulkAction.permission)) {
        return (
            <div className="filter-box-right button-box bulk-action-button-box">
                <Dropdown overlay={bulkActionDropDownList} trigger={['click']} placement="bottomRight">
                    <Button>
                        <EllipsisOutlined />
                    </Button>
                </Dropdown>
            </div>
        );
    }

    return <></>

}

export default BulkAction;